import moment from 'moment';

export const onTheMinute = 'onTheMinute';

const utcTimeFormat = 'YYYY-MM-DDTHH:mm:ss.SSSZ';

const vueTime = () => {
  return {
    namespaced: true,
    state: {
      // moments are mutable, so store a string representation
      // so that the vuex state is not modified outside of mutations
      now: moment.utc().format(utcTimeFormat)
    },
    mutations: {
      updateNow(state, now) {
        state.now = now;
      }
    },
    getters: {
      now(state) {
        return moment.utc(state.now);
      },
      localTime(state, getters) {
        // .local() changes the underlying moment, so create a clone
        return getters.now.clone().local();
      },
      time(state, getters) {
        return getters.localTime.format('HH:mm');
      },
      date(state, getters) {
        return getters.localTime.format('dddd, Do MMMM YYYY');
      }
    },
    actions: {
      update({commit}) {
        commit('updateNow', moment.utc().format(utcTimeFormat));
      }
    }
  };
};

/**
 * @param {string|number} interval
 * @param {string} moduleName
 * @param {boolean} registerStore
 * @return {function}
 */
export default ({interval = 5000, moduleName = 'time', registerStore = true}) => store => {
  if (registerStore) {
    store.registerModule(moduleName, vueTime());
  }

  if (Number.isInteger(interval)) {
    // fixed interval
    interval = parseInt(interval);
    setInterval(() => {
      store.dispatch(`${moduleName}/update`);
    }, interval);
  } else if (interval === onTheMinute) {
    /**
     * update once a minute, close to the minute change
     */
    /* eslint-disable-next-line no-inner-declarations */
    function updateAndSchedule() {
      const now = moment.utc();
      store.commit(`${moduleName}/updateNow`, now.format(utcTimeFormat));

      const nextChange = (60 - now.seconds()) * 1000 - now.milliseconds();
      setTimeout(updateAndSchedule, nextChange);
    }
    updateAndSchedule();
  }
};

export {
  vueTime,
  moment
};
